// SHOULD MATCH IN FE AND API REPOS
import { z } from 'zod';

export type CreateCommercialApplication = z.TypeOf<typeof CreateCommercialApplicationSchema>;

export const CreateCommercialApplicationSchema = z.object({
  firstName: z.string().min(2).max(50),
  lastName: z.string().min(2).max(50),
  emailAddress: z.string().email(),
  primaryPhoneNumber: z.string(),

  dba: z.string(),
  federalTaxId: z.string(),
  yearsInBusiness: z.coerce.number().min(0).max(100),
  grossAnnualRevenue: z.string().transform((str) => parseInt(str.replace(/,/g, ''), 10)),
  legalEntityType: z.string(),
  ownersOwnMoreThan25: z.coerce.number().min(1).max(4),
  whatCompanyDoes: z.string(),
  businessAddressLine1: z.string().min(2).max(50),
  businessCity: z.string().min(2).max(50),
  businessState: z.string().min(2).max(50),
  businessZipCode: z.string().regex(/^\d{5}$/, 'Zip code must be exactly 5 digits'),
  businessWebsite: z.string().optional(),

  owners: z.array(
    z.object({
      ownerFirstName: z.string().min(2).max(50),
      ownerLastName: z.string().min(2).max(50),
      ownerJobTitle: z.string().min(2).max(50),
      ownerPhoneNumber: z.string(),
      ownershipPercentage: z.coerce.number().min(0).max(100),
      ownerSSN: z.string(),
      ownerDateOfBirth: z.string(),
      ownerCitizenship: z.string(),
      ownerCitizenshipOther: z.string(),
      ownersAddressLine1: z.string().min(2).max(50),
      ownersCity: z.string().min(2).max(50),
      ownersState: z.string().min(2).max(50),
      ownersZipCode: z.string(),
    })
  ),

  isEquipmentFinancing: z.boolean(),
  isWorkingCapitalFinancing: z.boolean(),
  isLineOfCreditFinancing: z.boolean(),
  isSmallBusinessLoanFinancing: z.boolean(),

  amountRequested: z.string().transform((str) => parseInt(str.replace(/,/g, ''), 10)),
  equipmentYear: z.coerce.number(),
  equipmentMake: z.string(),
  equipmentModel: z.string(),

  periodFinalizing: z.string(),
  agreeToTerms: z.boolean(),
  signature: z.string(),

  // dealer info
  dealerId: z.string().optional(),
  dealerLocation: z.string().optional(),
  dealerStock: z.string().optional(),
  dealerName: z.string().optional(),

  // Google
  token: z.string(),

  // phone application
  createdBy: z.string().optional(),
  phoneNumberCallback: z.string().optional(),

  // custom attributes
  customAttributes: z.record(z.string(), z.string()).optional(),
});
